import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { DialogView } from '@hb/coffee';

@Component({ name: 'TradeDialog' })
export default class TradeDialog extends Vue {
  @Prop({ default: false })
  private tradeShow!: boolean;

  @Prop({ default: '提交' })
  private confirmText!: string;

  @Prop()
  private title!: string;

  @Prop({ default: '' })
  private content!: string;

  @Prop({ default: '' })
  private cancelText!: string;

  // 埋点名称
  @Prop({ default: '' })
  private ubtPage!: string;

  @Watch('tradeShow')
  private dialogShow(tradeShow: boolean) {
    if (this.ubtPage && tradeShow) {
      this.$ubtPageButton(this.ubtPage);
    }
  }

  private onClosed() {
    this.$emit('close');
  }

  private onSubmit() {
    this.$emit('submit');
  }

  private onCancel() {
    this.$emit('cancel');
  }

  private render() {
    return (
      <DialogView
        show={this.tradeShow}
        title={this.title}
        message={this.content}
        closeable={false}
        showCancelButton={!!this.cancelText}
        confirmButtonText={this.confirmText}
        cancelButtonText={this.cancelText}
        onConfirm={this.onSubmit.bind(this)}
        onCancel={this.onCancel.bind(this)}
        onCloseIconClick={this.onClosed.bind(this)}
      />
    );
  }
}
